<template>
    <div class="article-home-why">
        <p>
            It's all my favourite things put together - connecting with people from all walks of life, spontaneous
            self-expression through movement, and enjoying body-tingling eclectic tunes.
        </p>
        <p>
            I've always struggled to sit still and I love to dance wherever I find myself and whenever I hear a note.
            But being on that dance floor gives me a feeling of euphoria unlike nothing else. It's my happy place,
            amplified tenfold when my partner is smiling with me.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeWhy',
};
</script>
